import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  script: 'data-script',
}
const qsAll = {
  sections: 'data-section-type*="image-banner"',
  images: 'data-image',
  clickables: 'data-banner-clickable',
}

const iObserver = new IntersectionObserver(items => {
  const target = items[0].target
  if (items[0].isIntersecting && target.querySelector(`[${qs.script}]`)) initSection(target)
})

const initSection = (section) => {
  const images = section.querySelectorAll(`[${qsAll.images}]`)
  const clickables = section.querySelectorAll(`[${qsAll.clickables}]`)
  images.forEach(image => {
    const scriptElement = image.querySelector(`[${qs.script}]`)
    if(scriptElement) {
      const scriptHtml = scriptElement.innerHTML
      scriptElement.remove()
      image.innerHTML += scriptHtml
    }
  })
  clickables.forEach(clickable => {
    clickable.addEventListener('click', () => {
      location.href = clickable.getAttribute(qsAll.clickables)
    })
  })
}

export const setupImageBanner = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => {
    if(section.querySelector(`[${qs.script}]`))
      iObserver.observe(section)
    else
      initSection(section)
  })
}